// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-card[data-v-0c984adc]{transition:filter .5s}.card--editing[data-v-0c984adc]{filter:brightness(.5)}.card-container[data-v-0c984adc]{overflow:auto}@media only screen and (min-width:960px){.card-container[data-v-0c984adc]{overflow:visible;overflow:initial}}.event-editor[data-v-0c984adc]{width:900px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
